import { create } from 'zustand';
import type { inferTypeFromStateCreator } from '@epihub/web/src/zustand/types';
import { zustandThemeSlice } from '../theme/theme';

export const useGlobalStore = create<
  inferTypeFromStateCreator<typeof zustandThemeSlice>
>((set, ...rest) => ({
  ...zustandThemeSlice(set, ...rest),
}));
